/* ════════════════════════════════════════════════
   TrackLab — Main JavaScript
   ════════════════════════════════════════════════ */

import { openSheet } from './v2/sheet.js';

// ═══ State ═══
let curNum = 0;
let curDen = 1;
let curAmt = 5;

// ═══ SITE CLOCK ═══
(function() {
  var colonOn = true;
  function tick() {
    var elH = document.getElementById('scH');
    var elM = document.getElementById('scM');
    var elColon = document.getElementById('scColon');
    if (!elH || !elM) return;
    var now = new Date();
    var h = now.getHours();
    var m = now.getMinutes();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(now);
      var ph = null, pm = null;
      parts.forEach(function(p) {
        if (p.type === 'hour') ph = parseInt(p.value, 10) % 24;
        if (p.type === 'minute') pm = parseInt(p.value, 10);
      });
      if (ph !== null && pm !== null && !isNaN(ph) && !isNaN(pm)) { h = ph; m = pm; }
    } catch (e) { /* fall back to local time */ }
    var hh = String(h % 12 || 12);
    var mm = (m < 10 ? '0' : '') + m;
    var ap = h < 12 ? 'AM' : 'PM';
    elH.textContent = hh;
    elM.textContent = mm;
    var elAp = document.getElementById('scAp');
    if (elAp) elAp.textContent = ap;
    var clockEl = document.getElementById('siteClock');
    if (clockEl) clockEl.setAttribute('aria-label', 'UK time ' + hh + ':' + mm + ' ' + ap);
    colonOn = !colonOn;
    if (elColon) elColon.classList.toggle('off', !colonOn);
  }
  tick();
  setInterval(tick, 1000);
})();

// ═══ LIVE COUNTDOWN UPDATER ═══
// Updates "Starts in X" text on compact rows in real time
(function() {
  function formatCountdown(totalSeconds) {
    if (totalSeconds <= 0) return null; // signals "Started"
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var full, brief;
    if (hours > 0 && minutes > 0) {
      full = hours + 'h ' + minutes + 'min';
      brief = hours + 'h ' + minutes + 'm';
    } else if (hours > 0) {
      full = hours + 'h';
      brief = hours + 'h';
    } else {
      full = minutes + 'min';
      brief = minutes + 'm';
    }
    return { full: full, brief: brief };
  }

  function updateCountdowns() {
    var rows = document.querySelectorAll('.compact-row[data-race-start]');
    var now = Date.now();
    rows.forEach(function(row) {
      var startMs = new Date(row.dataset.raceStart).getTime();
      if (isNaN(startMs)) return;
      var secsLeft = Math.floor((startMs - now) / 1000);
      var cdEl = row.querySelector('.cr-cd-val');
      if (!cdEl) return;

      // Skip rows already showing Started/Awaiting/Finished
      if (cdEl.classList.contains('cr-cd-started') || cdEl.classList.contains('cr-cd-awaiting')) return;
      if (cdEl.textContent.trim() === 'Finished') return;

      if (secsLeft <= 0 && secsLeft > -30) {
        // Within walk-to-post phase
        cdEl.className = 'cr-cd-val cr-cd-started';
        cdEl.textContent = window.innerWidth <= 700 ? 'Starting' : 'Heading to start';
      } else if (secsLeft <= -30) {
        // Past walk phase — race underway
        cdEl.className = 'cr-cd-val cr-cd-started';
        cdEl.textContent = 'Started';
      } else {
        var cd = formatCountdown(secsLeft);
        if (cd) {
          if (window.innerWidth > 700) {
            cdEl.textContent = 'Starts in ' + cd.full;
          } else {
            cdEl.textContent = cd.brief;
          }
        }
      }
    });
  }

  // Also update expanded race countdown bars
  function updateExpandedCountdowns() {
    var rows = document.querySelectorAll('.compact-row[data-race-start]');
    var now = Date.now();
    rows.forEach(function(row) {
      var raceId = (row.id || '').replace('row-', '');
      if (!raceId) return;
      var expanded = document.getElementById('expanded-' + raceId);
      if (!expanded) return;
      var startMs = new Date(row.dataset.raceStart).getTime();
      if (isNaN(startMs)) return;
      var secsLeft = Math.floor((startMs - now) / 1000);

      var timeEl = expanded.querySelector('.er-cd-time');
      if (!timeEl) return;
      if (timeEl.classList.contains('er-cd-started') || timeEl.classList.contains('er-cd-awaiting')) return;
      if (timeEl.textContent.indexOf('Finished') !== -1) return;

      if (secsLeft <= 0) {
        timeEl.className = 'er-cd-time er-cd-started';
        timeEl.textContent = 'Race has started';
      } else {
        var cd = formatCountdown(secsLeft);
        if (cd) timeEl.textContent = 'Starts in ' + cd.full;
      }
    });
  }

  // Run every 15 seconds — minute-level countdowns don't need per-second updates
  setInterval(function() {
    updateCountdowns();
    updateExpandedCountdowns();
  }, 15000);
  // Also run once after a short delay to catch any stale server-rendered values
  setTimeout(function() {
    updateCountdowns();
    updateExpandedCountdowns();
  }, 2000);
})();

// ═══ CONFIDENCE TIERS ═══
function getConfidenceTier(score) {
  return TL.scoreTier(score).label;
}

// ═══ MONEY-FIRST ODDS TEXT ═══
function moneyFirstText(num, den, stake) {
  if (!stake) stake = curAmt;
  var total = Math.round((num / den) * stake) + stake;
  return 'Bet \u00A3' + stake + ', get \u00A3' + total + ' back';
}

// ═══ VENUE FILTER (upcoming tab) ═══
function filterVenue(btn) {
  var tabs = document.querySelectorAll('.vf-tab');
  tabs.forEach(function(t) { t.classList.remove('on'); });
  btn.classList.add('on');

  var venue = btn.dataset.venue;
  var items = document.querySelectorAll('.race-wrap[data-venue]');
  var headers = document.querySelectorAll('.vg-header[data-venue]');
  var list = document.getElementById('compactList');

  if (venue === 'all') {
    items.forEach(function(el) { el.style.display = ''; });
    headers.forEach(function(h) { h.style.display = 'none'; });
    if (list) list.classList.remove('venue-mode');
  } else {
    items.forEach(function(el) {
      el.style.display = el.dataset.venue === venue ? '' : 'none';
    });
    headers.forEach(function(h) {
      h.style.display = h.dataset.venue === venue ? 'block' : 'none';
    });
    if (list) list.classList.add('venue-mode');
  }

  // Update meeting summary text
  var summaryEl = document.getElementById('meetingSummary');
  if (summaryEl) {
    if (venue === 'all') {
      summaryEl.textContent = summaryEl.getAttribute('data-all');
    } else {
      var jsonEl = document.getElementById('venueSummaries');
      if (jsonEl) {
        try {
          var summaries = JSON.parse(jsonEl.textContent);
          summaryEl.textContent = summaries[venue] || summaryEl.getAttribute('data-all');
        } catch (e) { /* fall back to all */ }
      }
    }
  }
}

// ═══ ODDS HELPERS ═══
function oddsExplainText(num, den) {
  return num + '/' + den + ' means \u00A3' + den + ' wins \u00A3' + num + ' (and you get your \u00A3' + den + ' back).';
}

function oddsChanceText(num, den) {
  var pct = Math.round((den / (num + den)) * 100);
  return 'Bookmakers think this horse has about a ' + pct + '% chance of winning';
}

function flash(el) {
  if (!el) return;
  el.classList.remove('val-flash');
  void el.offsetWidth; // reflow to restart animation
  el.classList.add('val-flash');
}

// Re-sort horse cards by score (FLIP animation)
function reorderByScore(poolId) {
  var pool = document.getElementById(poolId);
  if (pool) {
    var cards = Array.prototype.slice.call(pool.querySelectorAll('.hc'));
    if (cards.length < 2) return;

    // FIRST: record current positions
    var firstRects = {};
    cards.forEach(function(c) {
      firstRects[c.getAttribute('data-horse')] = c.getBoundingClientRect();
    });

    // Sort by score descending
    cards.sort(function(a, b) {
      return (parseInt(b.getAttribute('data-score')) || 0) - (parseInt(a.getAttribute('data-score')) || 0);
    });

    // Re-append in new order
    cards.forEach(function(c) { pool.appendChild(c); });

    // LAST: get new positions, INVERT, PLAY
    cards.forEach(function(c) {
      var horse = c.getAttribute('data-horse');
      var first = firstRects[horse];
      var last = c.getBoundingClientRect();
      var dx = first.left - last.left;
      var dy = first.top - last.top;
      if (dx === 0 && dy === 0) return;
      c.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      c.style.transition = 'none';
      void c.offsetWidth; // reflow
      c.style.transition = 'transform 0.4s ease';
      c.style.transform = '';
      c.addEventListener('transitionend', function handler() {
        c.style.transition = '';
        c.removeEventListener('transitionend', handler);
      });
    });
  }
}

// Update a horse card's odds display + data attrs. Call when real odds arrive.
function updateOdds(card, num, den) {
  card.dataset.num = num;
  card.dataset.den = den;
  var oddsStr = num + '/' + den;

  // Update money-first text
  var moneyEl = card.querySelector('.hc-odds-money');
  if (moneyEl) moneyEl.textContent = moneyFirstText(num, den, 5);

  // Update the fraction display
  var fracEl = card.querySelector('.hc-odds-frac');
  if (fracEl) fracEl.textContent = 'odds: ' + oddsStr;

  // Flash changed odds elements
  flash(moneyEl);
  flash(fracEl);

  // Update the bookmaker context line
  var bookieEl = card.querySelector('.hc-odds-bookie');
  if (bookieEl) {
    var pct = Math.round((den / (num + den)) * 100);
    bookieEl.textContent = 'Bookmakers say: ' + oddsStr + ' \u2014 that\u2019s about a ' + pct + '% chance';
  }

  // If this card is currently selected, refresh the bet panel too
  if (card.classList.contains('selected')) {
    curNum = num;
    curDen = den;
    document.getElementById('bpOdds').textContent = oddsStr;
    var mf = document.getElementById('bpMoneyFirst');
    if (mf) mf.textContent = moneyFirstText(num, den, curAmt);
    updateReturn();
  }
}

function updateScore(card, newScore, edgeLabel) {
  card.setAttribute('data-score', newScore);

  // Update edge label on card
  var tierEl = card.querySelector('.hc-sc-tier');
  if (edgeLabel) {
    if (!tierEl) {
      tierEl = document.createElement('div');
      tierEl.className = 'hc-sc-tier';
      var scDiv = card.querySelector('.hc-sc');
      if (scDiv) scDiv.insertBefore(tierEl, scDiv.querySelector('.hc-sc-lbl'));
    }
    tierEl.textContent = edgeLabel;
    flash(tierEl);
  } else if (tierEl) {
    tierEl.remove();
  }
}

// ═══ HORSE SELECTION + BET PANEL ═══
function selectHorse(card, name, score, odds, num, den) {
  // Deselect all visible horse cards
  document.querySelectorAll('.er-detail .hc').forEach(function(c) {
    c.classList.remove('selected');
  });

  // Select this one
  card.classList.add('selected');
  curNum = num;
  curDen = den;

  // Prepare bet panel data (but don't open it yet — user must click the bet button)
  document.getElementById('bpHorse').textContent = name;
  document.getElementById('bpScore').textContent = score + '%';
  document.getElementById('bpTier').textContent = getConfidenceTier(score);
  document.getElementById('bpOdds').textContent = odds;
  var mf = document.getElementById('bpMoneyFirst');
  if (mf) mf.textContent = moneyFirstText(num, den, curAmt);
  updateReturn();
}

// Open the bet panel — called from "Bet with bet365" button inside horse card
function openBetPanel() {
  document.getElementById('betPanel').classList.add('open');


  // Scroll bet panel into view
  document.getElementById('betPanel').scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function pickAmt(btn, amt) {
  document.querySelectorAll('.bp-amt').forEach(function(b) {
    b.classList.remove('sel');
  });
  btn.classList.add('sel');
  curAmt = amt;
  updateReturn();
  document.getElementById('bpNote').textContent =
    "Paid out by the bookmaker, not TrackLab.";
}

function updateReturn() {
  var profit = (curNum / curDen) * curAmt;
  var total = profit + curAmt;
  document.getElementById('bpBet').textContent = '\u00A3' + curAmt;
  document.getElementById('bpProfit').textContent = '\u00A3' + profit.toFixed(0);
  document.getElementById('bpTotal').textContent = '\u00A3' + total.toFixed(0);
  var mf = document.getElementById('bpMoneyFirst');
  if (mf) mf.textContent = moneyFirstText(curNum, curDen, curAmt);
}

function closePanel() {
  document.getElementById('betPanel').classList.remove('open');
  document.querySelectorAll('.er-detail .hc').forEach(function(c) {
    c.classList.remove('selected');
  });
}


// ═══ TABS ═══
document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('.tab');
  var contents = document.querySelectorAll('.tab-content');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('on'); });
      tab.classList.add('on');
      var target = tab.dataset.tab;
      contents.forEach(function(c) {
        c.style.display = (c.dataset.tabContent === target) ? '' : 'none';
      });
    });
  });


  // ─── Race data polling (odds + scores) ───────────────────────────
  (function() {
    var activePollers = {};

    function getRefreshInterval(raceEl) {
      if (cdEl) {
        var text = cdEl.textContent || '';
        if (text.indexOf('Started') >= 0 || text.indexOf('Awaiting') >= 0) return 10000;
      }
      var startIso = raceEl.getAttribute('data-race-start');
      if (startIso) {
        var minsAway = (new Date(startIso) - Date.now()) / 60000;
        if (minsAway <= 0) return 10000;
        if (minsAway <= 30) return 30000;
        if (minsAway <= 60) return 60000;
      }
      return 120000;
    }

    function pollRace(raceId, eventId, raceEl) {
      fetch('/api/race/' + eventId + '/updates/')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.entries) return;

          var pool = document.getElementById('pool-' + raceId);

          if (pool) data.entries.forEach(function(entry) {
            // Find card in pool or detail panel
            var card = null;
            var cards = pool.querySelectorAll('.hc');
            for (var i = 0; i < cards.length; i++) {
              if (cards[i].getAttribute('data-horse') === entry.horse_name) { card = cards[i]; break; }
            }
            if (!card) {
              var detail = document.getElementById('detail-' + raceId);
              if (detail) {
                var dc = detail.querySelectorAll('.hc');
                for (var i = 0; i < dc.length; i++) {
                  if (dc[i].getAttribute('data-horse') === entry.horse_name) { card = dc[i]; break; }
                }
              }
            }
            if (!card) return;

            // Update odds if changed
            var curNum = parseInt(card.getAttribute('data-num')) || 0;
            var curDen = parseInt(card.getAttribute('data-den')) || 0;
            if (entry.odds_num !== curNum || entry.odds_den !== curDen) {
              updateOdds(card, entry.odds_num, entry.odds_den);
            }

            // Update score or edge label if changed
            var curScore = parseInt(card.getAttribute('data-score')) || 0;
            var curTier = card.querySelector('.hc-sc-tier');
            var curEdge = curTier ? curTier.textContent : '';
            if (entry.tracklab_score !== curScore || entry.edge_label !== curEdge) {
              updateScore(card, entry.tracklab_score, entry.edge_label);
            }
          });

          // Re-sort cards by updated scores (skip result cards)
          if (pool && raceId.indexOf('res-') !== 0) reorderByScore('pool-' + raceId);

          // Update compact row top score
          var topScore = 0;
          data.entries.forEach(function(e) { if (e.tracklab_score > topScore) topScore = e.tracklab_score; });
          var compactRow = document.getElementById('row-' + raceId);
          if (compactRow) {
            var tsVal = compactRow.querySelector('.cr-ts-val');
            if (tsVal && parseInt(tsVal.textContent) !== topScore) {
              tsVal.textContent = topScore;
              flash(tsVal);
            }
          }
        })
        .catch(function() { /* silent — retry on next interval */ });
    }

    function startPolling(raceId, eventId, raceEl) {
      if (activePollers[raceId]) return;
      var interval = getRefreshInterval(raceEl);
      pollRace(raceId, eventId, raceEl);
      activePollers[raceId] = setInterval(function() {
        pollRace(raceId, eventId, raceEl);
      }, interval);
    }

    function stopPolling(raceId) {
      if (activePollers[raceId]) {
        clearInterval(activePollers[raceId]);
        delete activePollers[raceId];
      }
    }

    window._startRacePolling = startPolling;
    window._stopRacePolling = stopPolling;


    // Auto-start polling for all compact rows (skip finished results)
    document.querySelectorAll('.compact-row[data-event-id]').forEach(function(row) {
      var eventId = row.getAttribute('data-event-id');
      var raceId = row.id.replace('row-', '');
      if (eventId && raceId && raceId.indexOf('res-') !== 0) {
        startPolling(raceId, eventId, row);
      }
    });
  })();

  // ─── Mobile tooltip bottom-sheet ─────────────────────────────────
  (function() {
    if (window.innerWidth > 700) return;

    var releaseSheet = null;

    function closeSheet() {
      var sheet = document.querySelector('.mob-tip-sheet');
      var scrim = document.querySelector('.mob-tip-scrim');
      if (sheet) sheet.remove();
      if (scrim) scrim.remove();
      if (releaseSheet) { var release = releaseSheet; releaseSheet = null; release(); }
    }

    function extractTitle(trigger, tipSrc) {
      var shapTitle = tipSrc.querySelector('.shap-title');
      if (shapTitle) return shapTitle.textContent;
      var tipT = tipSrc.querySelector('.tip-t');
      if (tipT) return tipT.textContent;
      if (trigger.closest('.hc-sc')) return 'TrackLab Score';
      if (trigger.closest('.hc-odds')) return 'Odds';
      return 'Info';
    }

    function extractBody(tipSrc) {
      // SHAP tips — clone the structured rows
      var shapRows = tipSrc.querySelectorAll('.shap-row');
      if (shapRows.length) {
        var wrap = document.createElement('div');
        shapRows.forEach(function(r) { wrap.appendChild(r.cloneNode(true)); });
        return wrap.innerHTML;
      }
      // .tip elements — strip the title to avoid duplication
      var tipT = tipSrc.querySelector('.tip-t');
      if (tipT) {
        var clone = tipSrc.cloneNode(true);
        var titleEl = clone.querySelector('.tip-t');
        if (titleEl) titleEl.remove();
        return clone.innerHTML.trim();
      }
      // Plain text (hc-q-tip)
      return tipSrc.innerHTML;
    }

    function showSheet(trigger) {
      closeSheet();

      var tipSrc = trigger.querySelector('.tip') || trigger.querySelector('.hc-q-tip');
      if (!tipSrc) return;

      var title = extractTitle(trigger, tipSrc);
      var body  = extractBody(tipSrc);

      // Scrim
      var scrim = document.createElement('div');
      scrim.className = 'mob-tip-scrim';
      scrim.addEventListener('click', closeSheet);
      document.body.appendChild(scrim);

      // Bottom sheet
      var sheet = document.createElement('div');
      sheet.className = 'mob-tip-sheet';
      sheet.innerHTML =
        '<div class="mob-tip-sheet-header">' +
          '<span class="mob-tip-sheet-title">' + title + '</span>' +
          '<button class="mob-tip-sheet-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="mob-tip-sheet-body">' + body + '</div>';

      sheet.querySelector('.mob-tip-sheet-close').addEventListener('click', closeSheet);
      document.body.appendChild(sheet);
      releaseSheet = openSheet(sheet, { label: title, opener: trigger, onEscape: closeSheet, scrim: scrim });
    }

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.hc-q') || e.target.closest('.mt');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        showSheet(trigger);
      }
    });
  })();

  // ─── Mobile nav drawer ──────────────────────────────────────────
  (function() {
    var burger = document.getElementById('navBurger');
    if (!burger) return;

    var releaseNav = null;

    function closeNav() {
      var sheet = document.querySelector('.mob-nav-sheet');
      var scrim = document.querySelector('.mob-nav-scrim');
      if (sheet) sheet.remove();
      if (scrim) scrim.remove();
      burger.setAttribute('aria-expanded', 'false');
      if (releaseNav) { var release = releaseNav; releaseNav = null; release(); }
    }

    function openNav() {
      closeNav();

      // Scrim
      var scrim = document.createElement('div');
      scrim.className = 'mob-nav-scrim';
      scrim.addEventListener('click', closeNav);
      document.body.appendChild(scrim);

      // Build links from the hidden desktop nav
      function esc(t) {
        return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      // A link may carry data-hint: a short plain line under its name.
      function linkHtml(a, cls) {
        var hint = a.getAttribute('data-hint');
        return '<a href="' + a.getAttribute('href') + '" class="mob-nav-link' + cls + (hint ? ' mob-nav-link--hint' : '') + '">' +
          '<span class="mob-nav-label">' + esc(a.textContent.replace(/\s+/g, ' ').trim()) + '</span>' +
          (hint ? '<span class="mob-nav-hint">' + esc(hint) + '</span>' : '') + '</a>';
      }
      var desktopLinks = document.querySelectorAll('.nav-r .nav-a');
      var linksHtml = '';
      desktopLinks.forEach(function(a) {
        linksHtml += linkHtml(a, a.classList.contains('nav-a--on') ? ' mob-nav-link--on' : '');
      });
      var races = document.querySelector('.nav-r .nav-cta');

      // Sheet
      var sheet = document.createElement('div');
      sheet.className = 'mob-nav-sheet m-sheet';
      sheet.innerHTML =
        '<div class="mob-nav-header">' +
          '<span class="mob-nav-title">Menu</span>' +
          '<button class="mob-nav-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="mob-nav-links">' +
          '<a href="/" class="mob-nav-link' + (window.location.pathname === '/' ? ' mob-nav-link--on' : '') + '">Home</a>' +
          linksHtml +
          (races ? linkHtml(races, ' mob-nav-link--cta') : '<a href="/races/" class="mob-nav-link mob-nav-link--cta">See Today\'s Races &rarr;</a>') +
        '</div>';

      sheet.querySelector('.mob-nav-close').addEventListener('click', closeNav);
      document.body.appendChild(sheet);
      burger.setAttribute('aria-expanded', 'true');
      // A dialog: scroll lock, focus inside (Tab stays in), Esc closes, focus back to ☰
      releaseNav = openSheet(sheet, { label: 'Menu', opener: burger, onEscape: closeNav, scrim: scrim });
    }

    burger.addEventListener('click', openNav);
  })();

  // ═══ Scroll-to-top button ═══
  var scrollBtn = document.getElementById('scrollTop');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      scrollBtn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
  }
});
